import http from './http'
import { handleHttpError } from './httpHelpers'

export function guestLoginService(data) {
    return http.post('/core/api/v1/userprofile/autologinasguest', data, {
            headers: { 'groupname': 'Visitatore' }
        }, { skipAuthRefresh: true }).then(response => {
            return response.data;
        }).catch((e) => {
            return handleHttpError(e);
    });
}

export function userVerificationService(data) {
    let params = {
        "customFunc": {
            "name": "cf_verificaRegistrazioneUtente",
            "param": { ...data }
        }
    }

    return http.post('/core/api/v1/userprofile/customfunc', params, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function sendVerificationCodeService(data) {
    let params = {
        "customFunc": {
            "name": "inviaCodiceVerificaEmail",
            "param": { ...data }
        }
    }

    return http.post('/core/api/v1/userprofile/customfunc', params, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function createUserService(data) {
    let params = {
        "customFunc": {
            "name": "cf_creaUtenteVerificato",
            "param": { ...data }
        }
    }

    return http.post('/core/api/v1/userprofile/customfunc', params, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function userLoginService(data) {
    return http.post('/core/api/v1/userprofile/locallogin2', data, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

// export function getUserDataService() {
//     return http.get('/auth/me').then(response => {
//         return response.data;
//     }).catch((e) => {
//         return handleHttpError(e);
//     });
// }

//TODO: delete after new token refresh system seems stable
// export function reInitHttpHeader(token = null) {
//     if (token)
//         return http.defaults.headers.common['Authorization'] = token;

//     return delete http.defaults.headers.common['Authorization'];
// }